import print from 'print-js';

const REVOKE_OBJECT_URL_DELAY_MS = 60000;

function isMobileBrowser() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true;
  }

  // iPadOS 13+ may report as MacIntel
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
}

function openPdfInNewTab(url) {
  const opened = window.open(url, '_blank', 'noopener,noreferrer');

  if (opened) {
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function scheduleRevokeObjectUrl(url, shouldRevoke) {
  if (shouldRevoke) {
    window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_OBJECT_URL_DELAY_MS);
  }
}

/**
 * Print a PDF from a Blob or URL. On mobile browsers, opens the PDF in a new tab
 * so the user can print via the system viewer (print-js iframe printing is unreliable).
 */
export default function printPdf(source) {
  const createdFromBlob = source instanceof Blob;
  const url = createdFromBlob ? URL.createObjectURL(source) : source;

  if (isMobileBrowser()) {
    openPdfInNewTab(url);
    scheduleRevokeObjectUrl(url, createdFromBlob);
    return;
  }

  print({
    printable: url,
    type: 'pdf',
  });
  scheduleRevokeObjectUrl(url, createdFromBlob);
}



// WEBPACK FOOTER //
// ./src/utils/printPdf.js